import {
  Button,
  CircularProgress,
  Grid,
  Link,
  Stack,
  Typography,
} from "@mui/material";
import { Form, Formik, FormikHelpers } from "formik";
import { useCallback, useEffect, useState } from "react";
import * as yup from "yup";
import {
  AddFeedbackRequest,
  AssessmentAndSubmissionResponse,
  useAddFeedbackMutation,
} from "../../../redux/Assessment/assessmentApis";
import {
  CandidateDetails,
  JobRequestDetails,
} from "../../../redux/Hire/jobRequestApi";
import FormikInput from "../../../shared/components/FormikInput";
import DownloadFileChip from "./DownloadFileChip";
type Props = {
  assessment?: AssessmentAndSubmissionResponse | null;
  candidateDetail: CandidateDetails;
  job: JobRequestDetails;
};

const linkify = (text: string) => {
  var urlRegex =
    /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
  return text?.split(urlRegex).map((part) => {
    if (part.match(urlRegex)) {
      return (
        <Link href={part} target="_blank">
          {part}
        </Link>
      );
    }
    return part;
  });
};

const validationSchema = yup.object({
  feedBackText: yup.string().required("Feedback is required"),
});

const AssessmentFeedback = ({ assessment, candidateDetail, job }: Props) => {
  const [initialValues, setInitialValues] = useState<AddFeedbackRequest>({
    assessmentId: assessment?.assessmentId || 0,
    candidateId: candidateDetail.id.toString(),
    isPassed: false,
    feedBackText: "",
    jobId: job.jobId.toString(),
  });

  const [addFeedback, addFeedbackMutating] = useAddFeedbackMutation();

  useEffect(() => {
    if (assessment) {
      setInitialValues((prev) => ({
        ...prev,
        assessmentId: assessment?.assessmentId,
        feedBackText: assessment.feedBackText || "",
      }));
    }
  }, [assessment]);

  const handleSubmit = useCallback(
    (
      data: AddFeedbackRequest,
      formikHelper: FormikHelpers<AddFeedbackRequest>,
    ) => {
      addFeedback(data);
      formikHelper.resetForm();
    },
    [addFeedback],
  );
  return (
    <Grid container item direction={"column"} gap={1} my={2}>
      <Formik
        initialValues={initialValues}
        enableReinitialize
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <Grid container item direction={"column"} gap={1}>
              <Typography
                fontSize={"14px"}
                lineHeight={"20px"}
                fontWeight={"500"}
              >
                Feedback on candidate&apos;s test
              </Typography>
              <FormikInput
                label=""
                name="feedBackText"
                formikProps={formikProps}
                placeholder="Review candidate's assessment and add feedback"
                options={undefined}
                multiline
                fullWidth
                rows="5"
              />
            </Grid>
            <Grid container item direction={"column"} gap={1}>
              <Typography
                fontSize={"14px"}
                lineHeight={"20px"}
                fontWeight={"500"}
              >
                Candidate's Assessment
              </Typography>
              <Typography variant="body1">
                {linkify(assessment?.submissionText || "")}
              </Typography>
            </Grid>
            <Grid container item direction={"column"} gap={1} mt={2}>
              <Typography
                fontSize={"14px"}
                lineHeight={"20px"}
                fontWeight={"500"}
              >
                Candidate's Attachment
              </Typography>
              {assessment?.candidateAttachmentList.length ? (
                <Grid container item direction={"column"} gap={1}>
                  <Stack direction="row" spacing={1} flexWrap="wrap" gap={1}>
                    {assessment?.candidateAttachmentList.map((name) => (
                      <DownloadFileChip name={name} key={name} />
                    ))}
                  </Stack>
                </Grid>
              ) : null}
            </Grid>
            <Grid container item justifyContent={"flex-end"}>
              <Button
                type="submit"
                variant="contained"
                disabled={addFeedbackMutating.isLoading}
              >
                {addFeedbackMutating.isLoading ? (
                  <CircularProgress
                    size={24}
                    color="primary"
                  ></CircularProgress>
                ) : (
                  "Save Feedback"
                )}
              </Button>
            </Grid>
          </Form>
        )}
      </Formik>
    </Grid>
  );
};

export default AssessmentFeedback;
